import React from 'react';
import classes from './About.module.css';

const About = props => {
    return (
        <section className={`${classes["about-area"]} section-padding`} id="about">
            <div className="container wow fadeIn">
                <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                        <div className="area-title text-center">
                            <h2>Our Story</h2>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                        <div className={classes["about-content"]}>
                            <p><span className={classes["big-text"]}>M</span> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ut fuga obcaecati voluptas repellat, quasi quisquam sapiente molestiae officiis assumenda ipsam autem quo magnam ipsa corrupti doloremque facere. Rem, commodi neque? </p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                        <div className="right-about-content">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam sit quasi explicabo aspernatur odio nihil vero asperiores nostrum ipsam quod et, culpa totam error cum quis voluptatem corrupti magnam quidem.</p>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                        <div className="about-author-sign text-center">
                            <img src="../../src/components/img/about/about_sign.png" alt="" />
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className={`${classes["about-author-sign"]} text-center`}>
                        <img src="https://quomodosoft.com/html/dawat/demo/img/about/about_sign.png" alt="" />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default About;